import { useStudioStream } from "@/data/studio-react/useStudioStream";

export function useCustomerBalance(
  marketId: string | null,
  customerId: string | null | undefined
) {
  let cxTrdReceivable =
    useStudioStream("balance", marketId, {
      account: customerId && `${customerId}:asset:trade receivable`,
    }) || 0;

  let cxTrdPayable =
    useStudioStream("balance", marketId, {
      account: customerId && `${customerId}:liability:trade payable`,
    }) || 0;

  let customerBalances =
    cxTrdReceivable &&
    cxTrdPayable &&
    !cxTrdReceivable.loading &&
    !cxTrdPayable.loading
      ? {
          tradeReceivable: cxTrdReceivable.data!,
          tradePayable: cxTrdPayable.data!,
        }
      : null;

  let currentBalance =
    (customerBalances?.tradeReceivable ?? 0) +
    (customerBalances?.tradePayable ?? 0);

  return {
    currentBalanceTotal: currentBalance,
    customerBalances,
  };
}
